import { CartWidgetsActionTypes, CartWidgetsActionActions } from '@uxdf/direct-shared-lib';

export interface State {
  isLoading: boolean;
  qty: number;
  dm: boolean;
}

/* eslint-disable */
function getInitialState(): State {
  return {
    isLoading: true,
    qty: 0,
    dm: false
  };
}

const initialState: State = getInitialState();

/* eslint-disable */
export function reducer(state = initialState, action: CartWidgetsActionActions): State {
  switch (action.type) {
    case CartWidgetsActionTypes.GetCartWidgetData: {
      return { ...getInitialState(), isLoading: true };
    }

    case CartWidgetsActionTypes.SetCartWidgetData: {
      return {
        ...state,
        isLoading: false,
        qty: action.payload['items'].reduce((sum, item) => sum + item.qty, 0),
        dm: action.payload['dm']
      };
    }

    default:
      return state;
  }
}
